import { TbMathGreater } from "react-icons/tb"

export const CardTitle = ({ text }) => (
  <h1 className="font-ocr text-xl text-dashboardhighlight">
    <TbMathGreater className="inline" /> {(text || "").toUpperCase()}
  </h1>
)
